<template>
  <div v-if="showPage" class="yxt-biz yxtbiz-attachment-list">
    <ul class="mr-16 layout-flex layout-flex-wrap">
      <li
        v-for="file in showFiles"
        :key="file.fileId || file.uuid"
        class="mt16 mb8 mr16"
        :style="{width: attachmentItemWidth}"
      >
        <Attachment
          :image-height="attachmentItemHeight"
          :show-delete="isEdit"
          :file="file"
          :file-status-hidden="fileStatusHidden"
          @delete="$emit('delete',file)"
          @preview="handlePreview(file)"
          @download="handleDownload(file)"
        />
      </li>
    </ul>
    <!-- 展开全部/收起全部 -->
    <OpenCloseAll
      v-if="showLimit > -1 && files.length > showLimit && !isEdit"
      :open.sync="open"
      class="mb8"
    />
    <yxtbiz-course-player
      :download-cb="(fileId)=>handleDownload({fileId})"
      :visible.sync="showCoursePlayer"
      :file-id-list="fileIdList"
      :start="coursePlayerStart"
      :join-kng="false"
    />
<!--    &lt;!&ndash; 图片预览 &ndash;&gt;-->
<!--    <ViewImage-->
<!--      v-show="showImageViewer"-->
<!--      ref="viewImage"-->
<!--      :url-list="imgUrlList"-->
<!--      :on-close="() => (showImageViewer = false)"-->
<!--    />-->
<!--    &lt;!&ndash; 视频、音频预览 &ndash;&gt;-->
<!--    <ViewMedia ref="viewMedia" />-->
<!--    &lt;!&ndash; 文档播放器 &ndash;&gt;-->
<!--    <ViewDoc ref="viewDoc" />-->
  </div>
</template>

<script>
import Attachment from './components/attachment.vue';
import attachmentListMixin from './mixins/attachment-list-mixin';

export default {
  name: 'YxtbizAttachmentList',
  mixins: [attachmentListMixin],
  components: {
    Attachment
  },
  data() {
    return {
      kngLibFile: {
        fileId: '',
        fileName: '',
        fileSize: 0,
        fileExt: ''
      },
      coursePlayerStart: 0,
      showCoursePlayer: false
    };
  },
  computed: {
    fileIdList: ({ list }) => list.map(file => file.fileId)
  },
  methods: {
    handlePreview(file) {
      if (this.noPreview) {
        // 不允许预览，则执行下载操作
        this.handleDownload(file);
        return;
      }

      this.setVoiceState(); // 停止录音播放
      this.previewDocAndImg(file.fileId);
    },
    previewDocAndImg(fileId) {
      const startIndex = this.fileIdList.findIndex(id => id === fileId);
      Object.assign(this, {
        coursePlayerStart: startIndex > -1 ? startIndex : 0,
        showCoursePlayer: true
      });
    }
  }
};
</script>
